// =============================================================================
// 404 NOT FOUND HANDLER COMPONENT
// =============================================================================

import React from 'react';

interface NotFoundHandlerProps {
  children: React.ReactNode;
}

/**
 * Component that wraps the app for 404 handling
 * Server-side 404 handling is now managed by the Cloud Function
 * This component is kept for potential future client-side enhancements
 */
export const NotFoundHandler: React.FC<NotFoundHandlerProps> = ({ children }) => {
  return <>{children}</>;
};
